require('./myFeedController');
require('../../shared/userFeed/userFeedDirective');

"use strict";

angular.module('app.myHockeyTv.myFeed', [
    'app.myHockeyTv.myFeed.myFeedController',
    'app.shared.userFeed.userFeedDirective'
])
    .config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider
                .state('app.myHockeyTv.myFeed', {
                    url: '/my_feed?:type',
                    templateUrl: 'components/myHockeyTv/myFeed/myFeedView.html',
                    controller: 'app.myHockeyTv.myFeed.myFeedController',
                    subTitle: 'My Feed',
                    isChildState: true
                })
                .state('app.myHockeyTv.myClips', {
                    url: '/my_clips',
                    templateUrl: 'components/myHockeyTv/myFeed/myFeedView.html',
                    controller: 'app.myHockeyTv.myFeed.myFeedController',
                    subTitle: 'My Clips',
                    isChildState: true,
                    params: {
                        type: 'clips'
                    }
                });
        }
    ]);



// WEBPACK FOOTER //
// ./app.v2/components/myHockeyTv/myFeed/myFeed.js